"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWAP_PROGRAM_ID = exports.ZERO_TS = exports.DEFAULT_TOKEN_DECIMALS = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.DEFAULT_TOKEN_DECIMALS = 6;
exports.ZERO_TS = 0;
exports.SWAP_PROGRAM_ID = new web3_js_1.PublicKey("SSwpkEEcbUqx4vtoEByFjSkhKdCT862DNVb52nZg1UZ");
//# sourceMappingURL=constants.js.map